import type { FC } from 'react';
import React, { createContext, useContext, useMemo } from 'react';

import type {
  PricesLoadTimeMetricIntegrationContextType,
  MetricLauncher,
} from '@/clientState/providers/PricesLoadTimeMetricIntegrationProvider/types';

const noop: MetricLauncher = () => {
  /**/
};

const PricesLoadTimeMetricIntegrationContext =
  createContext<PricesLoadTimeMetricIntegrationContextType>({
    start: noop,
    end: noop,
  });

const PricesLoadTimeMetricIntegrationProvider: FC<
  PricesLoadTimeMetricIntegrationContextType & { children: React.ReactNode }
> = ({ start, end, children }) => {
  const value = useMemo(() => ({ start, end }), [start, end]);
  return (
    <PricesLoadTimeMetricIntegrationContext.Provider value={value}>
      {children}
    </PricesLoadTimeMetricIntegrationContext.Provider>
  );
};

export const usePricesLoadTimeMetricIntegration = () =>
  useContext(PricesLoadTimeMetricIntegrationContext);

export default PricesLoadTimeMetricIntegrationProvider;
